module.exports = __webpack_public_path__ + "5009c3afc4d5cdbe89194a7d5c2d8e3a.svg";